import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { eventBus } from "@/helpers/eventBus";
  import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
  import "@webzlodimir/vue-bottom-sheet/dist/style.css";
  import { nextTick, onMounted, onUnmounted, ref } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SwipeModal',
  emits: ["onClose"],
  setup(__props, { expose: __expose, emit: __emit }) {

  const myBottomSheet = ref<InstanceType<typeof VueBottomSheet>>();

  const emit = __emit;

  const open = () => {
    myBottomSheet.value?.open();
  };

  const close = () => {
    myBottomSheet.value?.close();
  };

  const onClosed = () => {
    emit("onClose");
  };

  __expose({ open, close });

  const updateCart = async () => {
    nextTick(() => {
      if (myBottomSheet.value) {
        const bottomSheet = document?.querySelector(".bottom-sheet");
        if (bottomSheet) {
          const bottomSheetMain = bottomSheet?.querySelector(
            ".bottom-sheet__main"
          ) as HTMLElement;
          const bottomSheetContent = bottomSheet?.querySelector(
            ".bottom-sheet__content"
          ) as HTMLElement;

          if (bottomSheetContent) {
            bottomSheetContent.style.height = `${
              bottomSheetMain.scrollHeight + 36
            }px`;
          }
        }
      }
    });
  };

  eventBus.on("cart-updated", updateCart);

  onMounted(() => {
    window.addEventListener("storage", updateCart);
  });

  onUnmounted(() => {
    window.removeEventListener("storage", updateCart);
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueBottomSheet), {
    onClosed: onClosed,
    ref_key: "myBottomSheet",
    ref: myBottomSheet,
    class: "bottom-sheet"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 512))
}
}

})